import { apiForPrivate } from '.';
import { TRUSTED_DRIVER_ENDPOINT, DEPARTMENT_ENDPOINT } from '../../config/ap';

const apiDepartments = apiForPrivate.injectEndpoints({
    overrideExisting: true,
    endpoints: build => ({
        getDepartmentClient: build.query({
            query: id => `${TRUSTED_DRIVER_ENDPOINT.CLIENTS}/${id}/department-clients`
        }),
        saveDepartmentClient: build.mutation({
            query: ({clientId, payload}) => ({
                url: `${TRUSTED_DRIVER_ENDPOINT.CLIENTS}/${clientId}/department-clients`,
                method: 'POST',
                body: payload,
            }),
        }),
    })
});

export const {
    useLazyGetDepartmentClientQuery,
    useSaveDepartmentClientMutation
} = apiDepartments;